import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeCtx = createContext({ theme: "dark", setTheme: () => {}, toggle: () => {} });

const LS_KEY = "atelis.theme";
/*
 * Non-sensitive UI preference — theme selection ("dark" | "light") lives in
 * localStorage so it survives reloads without a server round-trip. Same
 * pattern used by every SaaS theme toggle (Linear, Vercel, GitHub).
 */
function readInitial() {
  try {
    const saved = localStorage.getItem(LS_KEY);
    if (saved === "light" || saved === "dark") return saved;
  } catch { /* ignore */ }
  // Fall back to system preference on first visit.
  if (typeof window !== "undefined" && window.matchMedia) {
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  }
  return "dark";
}

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(readInitial);

  useEffect(() => {
    const body = document.body;
    if (!body) return;
    if (theme === "light") body.classList.add("theme-light");
    else body.classList.remove("theme-light");
    try { localStorage.setItem(LS_KEY, theme); } catch { /* ignore */ }
  }, [theme]);

  const setTheme = (next) => setThemeState(next === "light" ? "light" : "dark");
  const toggle = () => setThemeState((t) => (t === "light" ? "dark" : "light"));

  return (
    <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeCtx);
}
